import React, { useEffect, useRef, useState } from "react";
import { FaPaperPlane, FaPaperclip } from "react-icons/fa";
import { FaFile } from "react-icons/fa6";
import { BsDownload } from "react-icons/bs";
import { useLoader } from "../../context/LoaderContext";
import { axiosInstance } from "../../config/https";
import User from "../../assets/images/james-img.png";

export default function ChatComp() {
  const { startLoader, stopLoader } = useLoader();
  const [socket, setSocket] = useState(null);
  const [chats, setChats] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);
  const [messages, setMessages] = useState([]);
  const messageInput = useRef();
  const lastMessageRef = useRef(null);
  const attachmentInput = useRef(null);
  const LoginUser = JSON.parse(localStorage.getItem("user"));
  console.log("messages", messages);
  // console.log("selectedChat", selectedChat);

  // const createChat = () => {
  //   startLoader();
  //   axiosInstance
  //     .post(`/api/v1/chats`, {
  //       members: [76, 67],
  //     })
  //     .then((resp) => {
  //     })
  //     .catch((err) => {
  //       stopLoader();
  //     });
  // };

  useEffect(() => {
    // 👇️ scroll to bottom every time messages change
    lastMessageRef.current?.scrollIntoView({ behavior: "smooth" });

    // attachment send issue
    setTimeout(() => {
      lastMessageRef.current?.scrollIntoView();
    }, 1000);
    // attachment send issue
  }, [messages]);

  useEffect(() => {
    const getChats = () => {
      startLoader();
      axiosInstance
        .get(`/api/v1/chats`)
        .then((resp) => {
          stopLoader();
          const Data = resp.data;
          setChats(Data?.chatRooms);
        })
        .catch((err) => {
          stopLoader();
        });
    };
    getChats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openChat = (e) => {
    setSelectedChat(e);
    startLoader();
    personalRoomConnect();
    // http://127.0.0.1:8000/api/v1/chats/CqBPC5ZzRnd8cPwjKLQMri/messages
    axiosInstance
      .get(`http://127.0.0.1:8000/api/v1/chats/${e.roomId}/messages`)
      .then((resp) => {
        stopLoader();
        const Data = resp.data;
        setMessages(Data);
      })
      .catch((err) => {
        stopLoader();
      });
  };

  const personalRoomConnect = (e) => {
    // dispatch(setSelectedChat(e));
    // getMessages(e.id);
    let socket = new WebSocket(
      `ws://127.0.0.1:8000/ws/users/${LoginUser.user.id}/chat/`
    );

    socket.onopen = function (event) {
      console.log("WebSocket connection established conversation.");
    };

    socket.onmessage = function (event) {
      const data = JSON.parse(event.data);
      // console.log("Received message from server:", data);
      setMessages((prev) => [...prev, data]);
      if (messageInput.current) {
        messageInput.current.value = "";
      }
    };

    // Save the socket in state
    setSocket(socket);

    socket.onclose = function (event) {
      console.log("WebSocket connection closed.");
    };
  };

  const sendMessage = () => {
    if (socket && messageInput.current.value.trim() !== "") {
      // Send the message to the server
      let msg = {
        action: "message",
        roomId: selectedChat.roomId,
        message: messageInput.current.value,
        user: LoginUser.user.id,
      };

      socket.send(JSON.stringify(msg));
      messageInput.current.value = "";
    }
  };

  const sendAttachment = (e) => {
    if (socket && e.target.files.length !== 0) {
      const file = e.target.files[0];
      // if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        const base64 = reader.result;
        const base64Split = base64.split("data:image/png;base64,");

        let attachment_data = {
          content: base64Split[1],
          filename: "views.py",
          filetype: "text/plain",
        };

        let msg = {
          action: "attachment",
          roomId: selectedChat.roomId,
          attachment: attachment_data,
          user: LoginUser.user.id,
        };
        socket.send(JSON.stringify(msg));
        messageInput.current.value = "";
      };

      reader.readAsDataURL(file);
      // }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      sendMessage();
    }
  };

  const hanldeAttachment = () => {
    attachmentInput.current.click();
  };

  return (
    <section className="messages-sec pc-p-3">
      <div className="container-fluid px-5">
        <span className="a-link color-secondary">
          Messages({chats?.length})
        </span>
        <div className="row">
          <div className="col-lg-3 col-md-3 col-12">
            <div className="messages-note">
              {chats?.map((e, i) => (
                <div
                  className="messages-note-box active"
                  onClick={() => openChat(e)}
                  key={i}
                >
                  <div className="message-notify-box">
                    <div className="row">
                      <div className="col-lg-3">
                        <div className="message-note-ico">
                          <figure>
                            <img
                              src={
                                e?.member[0]?.profile
                                  ? process.env.REACT_APP_API_URL +
                                    e?.member[0]?.profile
                                  : User
                              }
                              alt="profile"
                            />
                          </figure>
                        </div>
                      </div>
                      <div className="col-lg-9">
                        <div className="message-note-content">
                          <h5>{e?.member[0]?.name}</h5>
                          <p>{e?.member[0]?.email}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {!selectedChat && !messages?.length && (
            <div className="col-lg-9 col-md-9 col-12 d-flex justify-content-center align-items-center">
              <h3>Get Started Chat</h3>
            </div>
          )}
          {selectedChat && (
            <div className="col-lg-9 col-md-9 col-12">
              <div className="primary-box message-main-box">
                <div className="message-container">
                  {!messages?.length && (
                      <h3 className="text-center">
                        Get Started Chat{" "}
                        {selectedChat &&
                          `with ${selectedChat?.member[0]?.name}`}
                      </h3>
                  )}
                  {messages?.map((e, i) =>
                    LoginUser.user.id === e.user ? (
                      <div className="message-box" key={i}>
                        <div className="row">
                          <div className="col-lg-11 col-md-11 col-12 text-right">
                            <div className="message-content">
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="primary-heading color-dark">
                                    <h6>
                                      <span>{e.timestamp}</span> {e.userName}
                                    </h6>
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <MessageType message={e} />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-1 col-md-1 col-12">
                            <div className="message-note-ico px-2">
                              <figure>
                                <img
                                  src={
                                    LoginUser.profile_picture
                                      ? LoginUser.profile_picture
                                          .profile_picture
                                      : User
                                  }
                                  alt="user"
                                />
                              </figure>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="message-box" key={i}>
                        <div className="row">
                          <div className="col-lg-1 col-md-1 col-12">
                            <div className="message-note-ico px-2">
                              <figure>
                                <img
                                  src={
                                    selectedChat?.member[0]?.profile
                                      ? process.env.REACT_APP_API_URL +
                                        selectedChat?.member[0]?.profile
                                          .profile_picture
                                      : User
                                  }
                                  alt="user"
                                />
                              </figure>
                            </div>
                          </div>
                          <div className="col-lg-11 col-md-11 col-12">
                            <div className="message-content">
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="primary-heading color-dark">
                                    <h6>
                                      {e.userName} <span>{e.timestamp}</span>
                                    </h6>
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <MessageType message={e} />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                  <div ref={lastMessageRef} />
                </div>
                <div className="message-input mt-3">
                  <div className="message-form">
                    <div className="row">
                      <div className="col-lg-10">
                        <div className="message-input">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Send Message..."
                            ref={messageInput}
                            onKeyDown={handleKeyDown}
                          />
                          <input
                            type="file"
                            ref={attachmentInput}
                            onChange={(e) => sendAttachment(e)}
                            hidden
                          />
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="message-btns">
                          <ul className="list-inline">
                            <li className="list-inline-item">
                              <a onClick={hanldeAttachment}>
                                <FaPaperclip />
                              </a>
                            </li>
                            <li className="list-inline-item">
                              <a onClick={sendMessage}>
                                <FaPaperPlane />
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

const MessageType = ({ message }) => {
  const handleDownload = (url, fileName) => {
    axiosInstance
      .get(url, {
        responseType: "blob",
      })
      .then((res) => {
        console.log(res.data);
        // res.data //Blog object
        const fileurl = URL.createObjectURL(res.data);
        const link = document.createElement("a");
        link.download = fileName;
        link.href = fileurl;
        link.click();
      });
  };

  if (message.file && message.file !== null) {
    return (
      <div className="card d-inline-block">
        <div className="card-body">
          <span>
            <FaFile size={30} />
            <span> {message?.file_name && message?.file_name} </span>
          </span>
          <span
            className="download-btn"
            onClick={() => handleDownload(message?.file, message?.file_name)}
          >
            <BsDownload size={18} />
          </span>
        </div>
      </div>
    );
  } else {
    return <p>{message.message}</p>;
  }
};
